import type { Component } from 'vue';
import SpinLoader from './SpinLoader.vue';
export default new Map<string, Component>([
  ['SpinLoader', SpinLoader],

]);



